import { useState, useEffect } from 'react'
import { FiMenu, FiX } from 'react-icons/fi'
import './Navbar.css'
import { useTranslation } from 'react-i18next';
import LanguageDropdown  from './LanguageDropdown';
import { Link } from 'react-router-dom';

const Navbar = ({ scrolled }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

const { t, i18n } = useTranslation();
  // const changeLanguage = (code) => {
  //   i18n.changeLanguage(code);
  //   document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
  // };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
   <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/" className="logo">
            <span className="logo-text">
              {t('navbar.brand.main')}
              <span className="logo-accent">{t('navbar.brand.accent')}</span>
            </span>
          </a>
        </div>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            {/* If you add nav links later, translate them here */}
          </ul>

          <div className="auth-buttons">
            <Link to="/login" className="btn btn-primary login-btn">
              {t('navbar.login')}
            </Link >
            <Link to="/register" className="btn btn-primary register-btn">
              {t('navbar.register')}
            </Link>
             {/* <div className="auth-buttons">
              <select
                onChange={(e) => changeLanguage(e.target.value)}
                value={i18n.language}
                className="lang-select btn btn-primary register-btn"
              >
                <option value="en">EN</option>
                <option value="fr">FR</option>
              </select>
            </div> */}
              {/* <div className="language-selector">
              {languages.map(lang => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`lang-btn ${i18n.language === lang.code ? 'active' : ''}`}
                >
                  <img src={lang.flag} alt={lang.label} className="flag-icon" />
                </button>
              ))}
            </div> */}
            <LanguageDropdown/>
          </div>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>
    </nav>
  )
}

export default Navbar